
import { invoker } from 'ramda'

const CENTER = true
const OFFSET = 50

export function successMessage(message, customClass = 'elsa-message success', otherAttrs = {}) {
  return invoker(1, '$message')({
    message,
    customClass,
    center: CENTER,
    offset: OFFSET,
    type: 'success',
    showClose: true,
    iconClass: 'elsa-icon-check-white',
    ...otherAttrs
  })
}

export function warningMessage(message, customClass = 'elsa-message warning', otherAttrs = {}) {
  return invoker(1, '$message')({
    message,
    customClass,
    center: CENTER,
    offset: OFFSET,
    type: 'warning',
    showClose: true,
    iconClass: 'elsa-icon-warning-white',
    ...otherAttrs
  })
}
